"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatString = void 0;
const formatRegex = new RegExp('{-?[0-9]+}', 'g');
/**
 * Format a string using a string template. Similar to C# `string.Format()`.
 *
 * @example
 * formatString('test {0} string', 20);
 * // 'test 20 string'
 *
 * @param template String template.
 * @param args Indexed arguments to insert into template.
 */
function formatString(template, ...args) {
    return template.replace(formatRegex, item => {
        const intVal = parseInt(item.substring(1, item.length - 1), 10);
        if (intVal >= 0) {
            return args[intVal];
        }
        else if (intVal === -1) {
            return '{';
        }
        else if (intVal === -2) {
            return '}';
        }
        return '';
    });
}
exports.formatString = formatString;
//# sourceMappingURL=formatString.js.map